/**
 * Manual J Load Calculation Options
 * Constants for room data collection
 */

// Room name options
export const ROOM_TYPES = [
  { value: 'living-room', label: 'Living Room' },
  { value: 'family-room', label: 'Family Room' },
  { value: 'master-bedroom', label: 'Master Bedroom' },
  { value: 'bedroom', label: 'Bedroom' },
  { value: 'kitchen', label: 'Kitchen' },
  { value: 'dining-room', label: 'Dining Room' },
  { value: 'bathroom', label: 'Bathroom' },
  { value: 'laundry', label: 'Laundry' },
  { value: 'office', label: 'Office' },
  { value: 'bonus-room', label: 'Bonus Room' },
  { value: 'garage', label: 'Garage' },
  { value: 'other', label: 'Other' },
];

// Conditioning status
export const CONDITIONING_OPTIONS = [
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' },
  { value: 'semi', label: 'Semi-conditioned' },
];

// Ceiling types
export const CEILING_TYPES = [
  { value: 'below-conditioned', label: 'Below conditioned space' },
  { value: 'below-unconditioned-attic', label: 'Below unconditioned attic' },
  { value: 'below-vented-attic', label: 'Below vented attic' },
  { value: 'cathedral', label: 'Cathedral or vaulted' },
  { value: 'flat-roof', label: 'Flat roof' },
];

// Window types
export const WINDOW_TYPES = [
  { value: 'single-pane', label: 'Single pane' },
  { value: 'double-clear', label: 'Double pane clear' },
  { value: 'double-low-e', label: 'Double pane low-e' },
  { value: 'triple-pane', label: 'Triple pane' },
];

// Window frame types
export const WINDOW_FRAME_TYPES = [
  { value: 'wood-vinyl', label: 'Wood or vinyl' },
  { value: 'aluminum-break', label: 'Aluminum with break' },
  { value: 'aluminum-no-break', label: 'Aluminum no break' },
];

// Compass directions
export const DIRECTIONS = [
  { value: 'N', label: 'N' },
  { value: 'NE', label: 'NE' },
  { value: 'E', label: 'E' },
  { value: 'SE', label: 'SE' },
  { value: 'S', label: 'S' },
  { value: 'SW', label: 'SW' },
  { value: 'W', label: 'W' },
  { value: 'NW', label: 'NW' },
];

// Window shading options
export const SHADING_OPTIONS = [
  { value: 'none', label: 'None' },
  { value: 'interior-blinds', label: 'Interior blinds' },
  { value: 'exterior-awning', label: 'Exterior awning' },
  { value: 'overhang', label: 'Overhang' },
  { value: 'trees', label: 'Trees or shade' },
];

// Wall construction types
export const WALL_CONSTRUCTION_TYPES = [
  { value: 'wood-2x4', label: 'Wood frame 2x4' },
  { value: 'wood-2x6', label: 'Wood frame 2x6' },
  { value: 'brick-veneer', label: 'Brick veneer' },
  { value: 'concrete-block', label: 'Concrete block' },
  { value: 'sip', label: 'SIP panel' },
  { value: 'icf', label: 'ICF' },
];

// Wall insulation values
export const WALL_INSULATION_OPTIONS = [
  { value: 'none', label: 'None' },
  { value: 'R-11', label: 'R-11' },
  { value: 'R-13', label: 'R-13' },
  { value: 'R-15', label: 'R-15' },
  { value: 'R-19', label: 'R-19' },
  { value: 'R-21', label: 'R-21' },
  { value: 'R-30', label: 'R-30' },
];

// Floor types
export const FLOOR_TYPES = [
  { value: 'slab', label: 'Slab on grade' },
  { value: 'basement-conditioned', label: 'Over basement (conditioned)' },
  { value: 'basement-unconditioned', label: 'Over basement (unconditioned)' },
  { value: 'crawlspace-vented', label: 'Over crawlspace (vented)' },
  { value: 'crawlspace-sealed', label: 'Over crawlspace (sealed)' },
  { value: 'open-air', label: 'Over open air' },
  { value: 'conditioned-space', label: 'Over conditioned space' },
];

// Floor insulation options
export const FLOOR_INSULATION_OPTIONS = [
  { value: 'none', label: 'None' },
  { value: 'R-11', label: 'R-11' },
  { value: 'R-19', label: 'R-19' },
  { value: 'R-30', label: 'R-30' },
];

// Door types
export const DOOR_TYPES = [
  { value: 'solid-wood', label: 'Solid wood' },
  { value: 'solid-window', label: 'Solid with window' },
  { value: 'sliding-glass', label: 'Sliding glass' },
  { value: 'french', label: 'French doors' },
];

// Default values for new items
export const DEFAULT_WINDOW = {
  width: 36,
  height: 48,
  type: 'double-low-e',
  frame: 'wood-vinyl',
  facing: 'S',
  shading: 'none',
};

export const DEFAULT_EXTERIOR_WALL = {
  length: 10,
  construction: 'wood-2x4',
  insulation: 'R-13',
  facing: 'N',
};

export const DEFAULT_DOOR = {
  type: 'solid-wood',
  width: 36,
  height: 80,
  facing: 'N',
};

export const DEFAULT_ROOM_DATA = {
  name: 'bedroom',
  conditioned: 'yes',
  floorArea: 0,
  ceilingHeight: 8,
  ceilingType: 'below-vented-attic',
  windows: [],
  exteriorWalls: [],
  floorType: 'slab',
  floorInsulation: 'none',
  doors: [],
  notes: '',
};
